import { useState } from 'react';
import { Link } from 'react-router-dom';
import { hotVideos } from '@/mocks/videos';

const categoryTabs = [
  { key: 'all', label: '全部' },
  { key: 'movie', label: '电影' },
  { key: 'tv', label: '电视剧' },
  { key: 'anime', label: '动漫' },
  { key: 'variety', label: '综艺' },
  { key: 'documentary', label: '纪录片' },
];

export default function HotVideos() {
  const [activeTab, setActiveTab] = useState('all');

  const filteredVideos = activeTab === 'all'
    ? hotVideos
    : hotVideos.filter((v) => v.category === activeTab);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热门视频
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              大家都在看 · 人气爆棚
            </p>
          </div>

          <div className="flex items-center justify-center flex-wrap gap-1.5 mb-8">
            {categoryTabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                  activeTab === tab.key
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {filteredVideos.map((video) => (
              <Link
                key={video.id}
                to={`/category/${video.category}`}
                className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-video overflow-hidden">
                  <img
                    src={video.cover}
                    alt={video.title}
                    title={`${video.title} - 宅男视频在线观看`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute bottom-2 right-2">
                    <span className="px-1.5 py-0.5 bg-black/75 text-white text-[11px] rounded whitespace-nowrap">
                      {video.duration}
                    </span>
                  </div>
                  <div className="absolute top-2 left-2">
                    <span className="px-1.5 py-0.5 bg-primary-500 text-white text-[11px] font-medium rounded whitespace-nowrap">
                      {video.quality}
                    </span>
                  </div>
                </div>
                <div className="p-3">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1.5">
                    {video.title}
                  </h3>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <div className="flex items-center gap-1">
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                      </div>
                      <span className="font-medium text-foreground-600">{video.rating}</span>
                    </div>
                    <span className="whitespace-nowrap">{video.source}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}